import { createRootRoute, redirect } from "@tanstack/react-router";
import { Loading } from "@/layouts/loading";
import { Outlet } from "@tanstack/react-router";
import { authStore } from "@/providers/authStore";

export const Route = createRootRoute({
    component: () => <Outlet />,
    loader: ({ location }) => {
        // Redirect to home if logged in user visits root path
        if (location.pathname === '/' && authStore.getRefreshToken() && authStore.getAccessToken()) {
            throw redirect({
                to: "/home",
            });
        }

        // Allow access to auth-related pages without requiring authentication
        const isAuthPage = location.pathname.startsWith('/login') || 
                         location.pathname.startsWith('/forgot-password') || 
                         location.pathname.startsWith('/reset-password');
        
        if (!isAuthPage) {
            if (!authStore.getRefreshToken()) {
                throw redirect({
                    to: "/login",
                });
            }
            if (!authStore.getAccessToken()) {
                throw redirect({
                    to: "/home",
                });
            }
        }
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
});